module.exports = __webpack_public_path__ + "img/gachabody.d85e793d.png";